import React from 'react'

import Reflux from 'reflux-react-16'

import LoginStore from '../../../stores/LoginStore.js'
import LoginActions from '../../../actions/LoginActions.js'

class LightSpeedInstall extends Reflux.Component {
    constructor(props) {
        super(props)

        this.store = LoginStore
    }

    componentDidMount() {
        const {history} = this.props

        const query = new URLSearchParams(history.location.search)
        const language = query.get('language')
        const timestamp = query.get('timestamp')
        const token = query.get('token')
        const signature = query.get('signature')
        const clusterId = query.get('cluster_id')
        const shopId = query.get('shop_id')

        LoginActions.installLightspeed(language, timestamp, token, signature, clusterId, shopId, (err) => {
            history.push('/klant/instellingen/koppelingen/webshops/lightspeed', {err, message: !err && 'Lightspeed koppeling is geactiveerd.'})
        })
    }

    render() {
        return (
            <div />
        )
    }
}

export default (LightSpeedInstall)
